<template>
  <b-form @submit.prevent="submitForm">
    <b-form-group :label="$t('importContactOption')">
      <b-form-radio-group required :options="importOptions" v-model="importOption" />
    </b-form-group>

    <b-form-group v-if="importOption === 0">
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <!-- <div>Chọn file upload <span class="text-danger">*</span></div> -->
          <div><a :href="activeFID == 1 ? 'static/import_contact_template_fid.xlsx' : 'static/import_contact_template.xlsx'"
              target="_blank">{{ $t("downloadSampleFile") }}</a></div>
          <!-- <div><a href="static/import_contact_template.xlsx" target="_blank">{{ $t("downloadSampleFile") }}</a></div> -->
        </div>
      </template>
      <b-form-file
        ref="fileInput"
        accept=".xlsx"
        placeholder=""
        @change.native="onFileChange"
      />
      <!-- <b-form-file v-model="listImage" multiple accept="image/*" placeholder="" /> -->
    </b-form-group>

    <b-form-group v-if="activeFID == 1 && importOption === 0">
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>{{ $t("faceImageTitle1") }} <span class="text-danger">({{ $t("faceImageTitle2") }})</span></div>
        </div>
      </template>
      <b-form-file v-model="listImage" multiple accept="image/*" :placeholder="$t('faceChosePlaceholder')" />
    </b-form-group>

    <!-- Ẩn tính năng/ upcode prod -->
    <b-form-group v-if="importOption === 1">
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div><a :href="'static/api_import_template.pdf'" target="_blank">{{ $t("viewTemplateAPIImportContact") }}</a>
          </div>
        </div>
      </template>
    </b-form-group>

    <b-form-group v-if="importOption === 1">
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>{{ $t("APIURLContactImport") }}</div>
        </div>
      </template>
      <b-form-input id="input-contact-title" type="text" v-model="apiUrl" name="apiUrl" maxlength="500"></b-form-input>
    </b-form-group>

    <b-form-group v-if="importOption === 1">
      <template v-slot:label>
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>{{ $t("TokenAPIContactImport") }}</div>
        </div>
      </template>
      <b-form-input id="input-contact-title" type="text" v-model="tokenApi" name="tokenApi"
        maxlength="5000"></b-form-input>
    </b-form-group>

    <div v-if="formErrorMsg" class="text-danger">{{ formErrorMsg }}</div>
    <div v-if="errorDataList.length > 0" class="text-danger listError">
      <p v-for="error in errorDataList" :key="error">{{ error }}</p>
    </div>

    <div class="text-right pt-3">
      <b-button type="button" variant="secondary" class="mr-3" @click="onClickCancel" :disabled="isSubmitting">{{
        $t("cancel") }}</b-button>
      <b-button type="submit" variant="primary" :disabled="isSubmitting">{{ $t("importFromFile") }}</b-button>
    </div>
  </b-form>
</template>

<style lang="scss" scoped>
.listError {
  padding: 15px;
  max-height: 300px;
  background-color: #fcedeed9;
  overflow: auto;
}
</style>

<script lang="ts">
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as contactService from "@/service/contactService";
import * as validationUtils from "@/service/validationUtils";

@Component
export default class ImportContactsFromExcelFileModal extends BaseComponent {

  @Prop({ required: true }) modalId: string;
  @Prop({ required: true }) activeFID: any;

  file: File = null;
  listImage: any = null;
  apiUrl: string = "";
  tokenApi: string = "";

  formErrorMsg = "";
  errorDataList = [];
  isSubmitting = false;

  importOption = 0;
  importOptions = [
    { value: 0, text: this.$t("importContactOption0").toString() },
    { value: 1, text: this.$t("importContactOption1").toString() },
  ];

  // Emit decorators only
  @Emit("submitted") __submitted() { }


  mounted() {

  }

  onClickCancel() {
    this.$bvModal.hide(this.modalId);
  }

  async submitForm() {
    this.formErrorMsg = "";
    this.isSubmitting = true;

    try {
      if (this.importOption === 1) {
        await contactService.importFromApi(this.apiUrl, this.tokenApi);
        return;
      }

      if (!this.file) {
        this.formErrorMsg = this.$t("vuilongchonFileImport").toString();
        return;
      }

      const isValid = await this.checkFileExcel(this.file);
      // this.resetFile();
      if (!isValid) return;

      await contactService.uploadContactsExcelFile(this.file);
      // Thành công mới reset
      this.resetFile();
      this.__submitted();
      this.toastSuccessDelay(this.$t("importContactsFromFileSuccessful").toString());
      this.$bvModal.hide(this.modalId);

    } catch (e) {
      this.resetFile();
      this.errorDataList = this.ErrorWithList(e);
    } finally {
      this.isSubmitting = false;
    }
  }

  private async checkFileExcel(file: File): Promise<boolean> {
    try {
      const XLSX = await import("xlsx");
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(new Uint8Array(data), { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Không có dữ liệu
      if (!rows || rows.length < 2) {
        this.formErrorMsg = this.$t("fileExcelNotData").toString();
        return false;
      }

      const dataRows = rows.slice(1);
      let lastRowIndex = -1;
      for (let i = dataRows.length - 1; i >= 0; i--) {
        const row = (dataRows[i] || []) as any[]; // 👈 ép kiểu
        const hasData = row.some(
          (cell: any) =>
            cell !== null &&
            cell !== undefined &&
            cell.toString().trim() !== ""
        );
        if (hasData) {
          lastRowIndex = i;
          break;
        }
      }
      if (lastRowIndex === -1) {
        this.formErrorMsg = this.$t("fileExcelNotData").toString();
        return false;
      }
      const validRows = dataRows.slice(0, lastRowIndex + 1);
      for (let i = 0; i < validRows.length; i++) {
        const row = (validRows[i] || []) as any[];
        const hasData = row.some(
          (cell: any) =>
            cell !== null &&
            cell !== undefined &&
            cell.toString().trim() !== ""
        );
        if (!hasData) {
          this.formErrorMsg =
            this.$t("fileExcelEmptyRowBetween").toString();
          return false;
        }
      }
      // Kiểm tra email trùng lặp
      const emails = validRows
        .map(row =>
          Array.isArray(row) ? (row[1]?.toString().trim().toLowerCase() || "") : ""
        )
        .filter(email => email);

      const emailSet = new Set<string>();
      const duplicateEmails = emails.filter(email => {
        if (emailSet.has(email)) return true;
        emailSet.add(email);
        return false;
      });
      if (duplicateEmails.length > 0) {
        this.formErrorMsg =
          this.$t("emailDuplicated").toString() + ": " + duplicateEmails.join(", ");
        return false;
      }

      // Kiểm tra họ tên
      for (let i = 0; i < validRows.length; i++) {
        if (!validRows[i][0] || validRows[i][0].toString().length < 2) {
          this.formErrorMsg = this.$t("fileExcelFullName").toString();
          return false;
        }
      }

      return true;
    } catch (err) {
      this.formErrorMsg = this.$t("fileExcelReadError").toString();
      return false;
    }
  }

  private resetFile() {
    if (this.$refs.fileInput) {
      (this.$refs.fileInput as any).reset();
    }
    // this.file = null;
  }

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files ? input.files[0] : null;

    if (file) {
      this.file = file;
      input.value = "";
    }
  }

}
</script>
